import React, { useContext } from 'react'

import AppHeader from './app-header'
import CancelButton from '../cancel-button'
import { ColumnFlexCentered } from '~/components/common/containers'
import { Context } from '../context'
import Product from './product'
import Spinner from '~/components/common/spinner'
import styled from 'styled-components'
import withNotifications from '~/components/with-notifications'

const StyledSpinner = styled(Spinner)`
  margin: 24px auto;
`

const Container = styled(ColumnFlexCentered)`
  margin: 48px 16px 16px 16px;

  a {
    color: #5e6d7a;
    font-size: 13px;
    text-decoration: none;
    text-align: center;
  }
`

const App = () => {
  const { products, getSession } = useContext(Context)

  return (
    <Container>
      <AppHeader />
      {!products.length && <StyledSpinner />}
      <ColumnFlexCentered fullWidth>
        {products.map(product =>
          <Product key={product.id} product={product} onGetSession={getSession} />
        )}
      </ColumnFlexCentered>
      <CancelButton />
    </Container>
  )
}

export default withNotifications(App)
